module.exports = __webpack_public_path__ + "img/std-ljubljana.6a3eb582.png";